import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function Blog() {
  useEffect(() => {
    fetch();
    document.getElementById('spinner').style.display = "none";
  });

  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/blog_get`);
    console.log(res);
    setData(res.data);
  };

  return (
    <>

      <div>
        <Header2 title="Blog" />
        <div className="container-fluid px-0 py-5 my-5">
          <div className="row mx-0 justify-content-center text-center">
            <div className="col-lg-6">
              <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                Our Blog
              </h6>
              <h1>Our Blog</h1>
              <div class="spinner-border text-danger mt-5" id='spinner'></div>
            </div>
          </div>
          {(data.length > 0) ? data &&
            data.map((value) => {
              return (
                <div className="container-fluid py-5">
                  <div className="container py-5">
                    <div className="row">
                      <div className="col-lg-6" style={{ minHeight: 500 }}>
                        <div className="position-relative h-100">
                          <img
                            className="position-absolute w-100 h-100"
                            src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/blog/${value.blog_img}`}
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 pt-5 pb-lg-5">
                        <div className="hours-text bg-light p-4 p-lg-5 my-lg-5">
                          <h1 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                            {value.title}
                          </h1>
                          <h1 className="mb-4"></h1>
                          <p></p>
                          <ul className="list-inline">
                            <li className="h6 py-1">
                              <i className="far fa-circle text-primary mr-3" />
                              {value.description}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }) : null}

        </div>
      </div>
      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>

    </>
  );
}

export default Blog;
